import { mergeExtensions, build, applyContainer } from '@factorin/container';

import { theme } from '../theme';



const extensions = mergeExtensions(
    
        require('../../src/core/react').react,
    
        require('../../src/core/redux').redux,
    
        require('../../src/core/forms').forms,
    
        require('../../src/core/messaging').messaging,
    
        require('../../src/core/api').api,
    
        require('../../src/core/i18n').i18n,
    
        require('../../src/core/helmet').helmet,
    
        require('../../src/core/mui').mui,
    
        require('../../src/business/yandex-metrics').yandexMetrics,
    
        require('../../src/business/data').data,
    
        require('../../src/business/registration').registration,
    
        require('../../src/business/landing-dfa').landingDfa,
    
        require('../../src/core/config').config,
    
    { config: {"configuration":"landing-dfa","pathPrefix":"/Frontend","apiPath":"/api"}, theme },
);
const container = applyContainer(build(extensions));
container.runApplication();
